import { FC, useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import styles from 'styles/components/template.module.scss'
import PageHedding from 'components/PageHedding/PageHedding'
import InputTextWithLightLabel from 'components/Form/WithLightLabel/InputText'
import SubmitButton from 'components/Button/SubmitButton'
import Table, { TableBody } from 'components/Table/Table'
import { getWholesalers, WholesalerType } from 'reducks/wholesaler/slice'
import { RootState } from 'reducks/reducers'

const WholesalerTemplate: FC = () => {
  const dispatch = useDispatch<any>()
  const navigate = useNavigate()
  const location = useLocation()
  const path = location.pathname
  const { staff } = useSelector((state: RootState) => state.staffSlice)
  const [wholesalerList, setWholesalerList] = useState<TableBody[][]>([])
  const [searchWord, setSearchWord] = useState<string>('')

  const handleSearchWord = (searchWord: string) => {
    setSearchWord(searchWord)
    filter({ inputSearchWord: searchWord })
  }

  const createWholesalerList = useCallback(
    (wholesalers: WholesalerType[], inputSearchWord?: string) => {
      const localSearchWord =
        inputSearchWord !== undefined ? inputSearchWord : searchWord

      let filteredWholesalers = wholesalers

      // 検索ワードでフィルタ
      if (localSearchWord) {
        filteredWholesalers = filteredWholesalers.filter((wholesaler) => {
          const searchTarget =
            `${wholesaler.id} ${wholesaler.name}`.toLowerCase()
          return searchTarget.includes(localSearchWord.toLowerCase())
        })
      }

      const newWholesalerList: TableBody[][] = filteredWholesalers.map(
        (wholesaler) => {
          const tableBody: TableBody[] = [
            {
              category: 'long_name',
              elementInfo: {
                text: {
                  label: wholesaler.name,
                },
              },
              active: true,
            },
            {
              category: 'status',
              elementInfo: {
                status: {
                  name: wholesaler.is_active ? '有効' : '無効',
                  color: wholesaler.is_active ? 'green' : 'gray',
                },
              },
              active: true,
            },
            {
              category: 'icon',
              elementInfo: {
                button: {
                  label: '',
                  color: 'white',
                  size: 'icon',
                  icon: 'edit_gray',
                  to: `/wholesaler/edit/${wholesaler.id}`,
                },
              },
              active: true,
            },
          ]
          return tableBody
        },
      )
      setWholesalerList(newWholesalerList)
    },
    [searchWord, navigate],
  )

  const filter = ({ inputSearchWord }: { inputSearchWord?: string }) => {
    const { wholesalers } = store.getState().wholesalerSlice
    createWholesalerList(wholesalers, inputSearchWord)
  }

  const { wholesalers } = useSelector(
    (state: RootState) => state.wholesalerSlice,
  )

  const store = {
    getState: () => ({
      wholesalerSlice: { wholesalers },
    }),
  }

  const dispatchGetWholesalers = useCallback(async () => {
    const wholesalersPayload = await dispatch(
      getWholesalers({ includeInactive: true }),
    )
    createWholesalerList(wholesalersPayload.payload)
  }, [dispatch, createWholesalerList])

  useEffect(() => {
    if (!staff) {
      navigate('/initload?path=' + path)
      window.scrollTo(0, 0)
      return
    }
    if (!staff.isAdmin) {
      navigate('/initload')
      window.scrollTo(0, 0)
      return
    }
    dispatchGetWholesalers()
  }, [staff, navigate, path, dispatchGetWholesalers])

  const handleSubmmit = async (to: string | undefined) => {
    if (to) {
      const id = to.split('/wholesaler/edit/')[1]
      if (id) {
        navigate(to)
      }
    }
  }

  const toAddPage = () => {
    navigate('/wholesaler/add')
  }

  return (
    <div className={styles.container}>
      <PageHedding title="問屋マスター" to="" />
      <div className={styles.pattern}>
        <div className={styles.pattern_head}>
          <InputTextWithLightLabel
            labelName="フリーワード検索"
            description=""
            line={1}
            type="text"
            size="xlarge2"
            value={searchWord}
            placeholder="問屋コードまたは問屋名で検索"
            onChange={(event) => handleSearchWord(event.target.value)}
          />
          <SubmitButton
            label="問屋を新規登録"
            color="orange"
            size="xlarge"
            icon="plus"
            onClick={() => toAddPage()}
          />
        </div>

        <div className={styles.pattern_table}>
          <Table
            headers={[
              {
                category: 'long_name',
                elementInfo: {
                  text: {
                    label: '問屋名',
                  },
                },
              },
              {
                category: 'status',
                elementInfo: {
                  text: {
                    label: 'ステータス',
                  },
                },
              },
              {
                category: 'icon',
                elementInfo: {
                  text: {
                    label: '編集',
                  },
                },
              },
            ]}
            bodies={wholesalerList}
            handleSubmmit={handleSubmmit}
          />
        </div>
      </div>
    </div>
  )
}

export default WholesalerTemplate
